import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
  type MutableRefObject,
} from 'react';
import { GammaImpact, TotalOIPutCallImpactConfig } from '../../../types';
import { BrushZoomConfig } from '../../../types/shared';

export interface TotalOIPutCallImpactContextValue {
  selectedSym: string;

  config: TotalOIPutCallImpactConfig;
  updateConfig: (patch: Partial<TotalOIPutCallImpactConfig>) => void;

  initialData: GammaImpact[];
  setInitialData: Dispatch<SetStateAction<GammaImpact[]>>;

  zoomConfig: BrushZoomConfig;
  setZoomConfig: Dispatch<SetStateAction<BrushZoomConfig>>;

  chartRef: MutableRefObject<HTMLDivElement | null>;
}

export const TotalOIPutCallImpactContext =
  createContext<TotalOIPutCallImpactContextValue | null>(null);

export const useTotalOIPutCallImpactCtx = () => {
  const ctx = useContext(TotalOIPutCallImpactContext);
  if (ctx == null) {
    throw new Error(
      'useTotalOIPutCallImpactCtx must be used within a TotalOIPutCallImpactProvider',
    );
  }
  return ctx;
};
